export const HOURLY_RATE_TYPE_CODES = ['U', 'D<2', 'D>2', 'S']

export const HOURLY_RATE_TYPES = [
	{ code: 'U', labelKey: 'hourlyRateTypes.U', defaultLabel: 'Uczniowie (U)' },
	{ code: 'D<2', labelKey: 'hourlyRateTypes.D_lt_2', defaultLabel: 'Dorośli do 2h (D<2)' },
	{ code: 'D>2', labelKey: 'hourlyRateTypes.D_gt_2', defaultLabel: 'Dorośli powyżej 2h (D>2)' },
	{ code: 'S', labelKey: 'hourlyRateTypes.S', defaultLabel: 'Szkolenie sprzedawców (S)' },
]

export const DEFAULT_HOURLY_RATE_TYPE = 'U'

export const emptyStawkiGodzinowe = () => ({
	U: '',
	'D<2': '',
	'D>2': '',
	S: '',
})

const toRateString = value => {
	if (value === '' || value == null) return ''
	return `${value}`.trim()
}

export const normalizeStawkiGodzinowe = (source = {}, fallbackRate = '') => {
	const raw = source?.stawki_godzinowe && typeof source.stawki_godzinowe === 'object'
		? source.stawki_godzinowe
		: source
	const fallback = toRateString(fallbackRate || source?.stawka_godzinowa || source?.defaultHourlyRateGross)

	return {
		U: toRateString(raw?.U) || fallback,
		'D<2': toRateString(raw?.['D<2']),
		'D>2': toRateString(raw?.['D>2']),
		S: toRateString(raw?.S),
	}
}

export const resolveHourlyRateByType = (source, rateType = DEFAULT_HOURLY_RATE_TYPE) => {
	const rates = normalizeStawkiGodzinowe(source)
	const code = HOURLY_RATE_TYPE_CODES.includes(rateType) ? rateType : DEFAULT_HOURLY_RATE_TYPE
	const selected = rates[code]
	if (selected !== '') return selected
	return rates.U || toRateString(source?.stawka_godzinowa || source?.defaultHourlyRateGross)
}

export const normalizeTypStawkiGodzinowej = value => (
	HOURLY_RATE_TYPE_CODES.includes(value) ? value : DEFAULT_HOURLY_RATE_TYPE
)
